<template>
  <div>
    <b-card class="my-2">
      <template #header>
        <h4>Viajes</h4>
      </template>
      <select v-model="selViaje" class="my-1 form-control custom-select">
        <option v-for="v in Vigentes" :key="v.id" :value="v.id">{{ v.text }}</option>
      </select>
    </b-card>

    <b-card>
      <template #header>
        <h4>Reportes</h4>
      </template>
      <div class="my-2">
        <b-list-group>
          <b-list-group-item @click="enrutar('/NoEntregado/' + selViaje)" button>No entregados</b-list-group-item>
          <b-list-group-item @click="enrutar('/OrdenEntregar/'+selViaje)" button>Listado de entregas</b-list-group-item>
          <b-list-group-item @click="enrutar('/Manifiesto/' + selViaje)" button>Manifiesto de carga</b-list-group-item>
          <b-list-group-item @click="enrutar('/Aereolinea/' + selViaje)" button>Manifiesto de Aereolinea</b-list-group-item>
          <b-list-group-item @click="enrutar('/Consolidar/' + selViaje)" button>Consolidacion de Envio</b-list-group-item>
          <b-list-group-item @click="enrutar('/ConsolidarII/' + selViaje)" button>Consolidacion de Envio II</b-list-group-item>
          
        </b-list-group>
      </div>
    </b-card>
  </div>
</template>

<script>

let fecha = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
fecha.setDate(fecha.getDate() - 15);

let Ahora = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
Ahora.setDate(Ahora.getDate() - 1);

let txtFecha = function(fecha) {
  
  if(typeof fecha == 'string') fecha=new Date(fecha)
  return fecha.toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" });
};

export default {
  mounted(){
    this.Viajes=JSON.parse(localStorage.Viajes);
  },
  watch: {
    Viajes(v) {
      if (v.length) {
        this.selViaje = this.Vigentes[0].id;
      }
    },
  },
  methods: {
    enrutar(v) {
      this.$router.push(v);
    },
  },
  computed: {
    Vigentes() {
      let vig = this.Viajes.filter((item) => {
        return  new Date(item.fecha) >= fecha;
      })
        .sort((a, b) => (a.fecha < b.fecha && 1) || -1)
        .map((item) => {
          return {
            id: item.id,
            text: item.origen + " ==> " + item.destino + ",  " + txtFecha(item.fecha),
            disponible: new Date(item.fecha) > Ahora,
          };
        });

      return vig;
    },
  },
    beforeCreate(){
    let aplica=this.$session.get('EsAdmin');
    if(!aplica) this.$router.push('/courier/home')
  },
  data() {
    return {
      Viajes: [],
      selViaje: null,
    };
  },

};
</script>

<style scoped>
.card-header {
  background-color: #def;
}
</style>
